import useMainStore from "store/mainStore";
import ProductDiscountItem from "apps/Activity/components/ProductDiscountLines";
import funcs from "tools/functions";
import useChildStore from "store/childStore";
import proxy from "api/proxy";

const searchUnit = (value, record) => {
  const dom = [["category", "=", record?.unit?.category]];
  if (value) {
    dom.push(["name", "ilike", `%${value}%`]);
  }
  return dom;
};

const getProduct = (value) => {
  const search = [
    "OR",
    [
      ["template.name", "ilike", `%${value}%`],
      ["template.salable", "=", true],
    ],
    [
      ["code", "ilike", `${value}%`],
      ["template.salable", "=", true],
    ],
  ];
  return search;
};

const getSalePrices = async (record) => {
  if (!record.product) return {};
  const parentRec = useMainStore.getState().record;
  const party = funcs.prepareRecord(parentRec.party);
  const store = useChildStore.getState().store;
  const line = {
    product: store.product,
    quantity: Number(store.quantity),
    sale: {
      party: party,
      invoice_party: party,
      price_list: parentRec?.price_list?.id,
    },
  };
  const unit = record.unit?.id ?? record.product["sale_uom."].id;
  const { data: result } = await proxy.methodInstance({
    model: "sale.line",
    method: "on_change_product",
    instance: line,
    args: [],
    ctx: {
      price_list: parentRec?.price_list?.id,
      uom: unit,
      party: parentRec?.party?.id,
      invoice_party: parentRec?.party?.id,
    },
  });

  const taxes = [];

  if (result?.taxes?.add) {
    for (const item of result.taxes.add) {
      taxes.push(item[1].id);
    }
  }
  line.taxes = taxes;
  line.quantity = store.quantity || 1;
  result.unit_price = result.unit_price ?? result.base_price;
  line.unit_price = result.unit_price;

  const { data: unit_price_w_tax } = await proxy.methodInstance({
    model: "sale.line",
    method: "on_change_with_unit_price_w_tax",
    instance: line,
    args: [],
    ctx: {
      price_list: parentRec?.price_list?.id,
      uom: unit,
      party: parentRec?.party?.id,
      invoice_party: parentRec?.party?.id,
    },
  });
  return { result: result, price_w_tax: unit_price_w_tax, taxes: taxes };
};

const onChangeProduct = async (record, store) => {
  const product = record?.product;
  if (store.undefined) {
    delete store.undefined;
  }

  if (product) {
    const unit = product["sale_uom."];
    const { result, price_w_tax, taxes } = await getSalePrices(record);
    record.base_price = result?.base_price;
    record.unit_price = result?.unit_price;
    record.unit = unit;
    record.unit_price_w_tax = price_w_tax;
    record.amount_w_tax = price_w_tax;
    record.description = result?.description;
    store.description = product.description || product.name;
    store.unit_price = result?.unit_price.toString();
    store.base_price = result?.base_price.toString();
    store.unit = unit.id;
    store.taxes = [["add", taxes]];
  }
};

const getAmountDiscount = (record) => {
  if (record?.quantity && record?.discount_amount) {
    return record.discount_amount;
  }
};

const getAmountWTax = (record) => {
  if (record?.quantity && record?.unit_price_w_tax) {
    return record.quantity * record.unit_price_w_tax;
  }
};

const getDiscount = (record) => {
  if (record?.discount_rate) {
    return (record.discount_rate * 100).toFixed(2).toString() + " %";
  }
};

const accDelete = (rec, parentRec) => {
  console.log(parentRec, "parent rec", rec);

  let res = true;
  if (rec?.state !== "draft") {
    res = false;
  }
  return res;
};

const readOnlyQuantity = (record) => {
  const parentRec = useMainStore.getState().record;
  if (parentRec.state !== "draft") {
    return true;
  }
  return false;
};

const onChangeQty = async (record, store) => {
  const parentRec = useMainStore.getState().record;

  if (parentRec.lines.size > 0) {
    const totalAmount = Array.from(parentRec.lines.values()).reduce(
      (total, item) => {
        const sale_price =
          item.unit_price_w_tax ?? item.product.sale_price_w_tax;
        return total + item.quantity * sale_price;
      },
      0,
    );
    parentRec.total_amount = Number(totalAmount.toFixed(0));
  }
};

async function onChangeUnitPriceWtax(record, store) {
  const parentRec = useMainStore.getState().record;
  if (parentRec.state !== "draft") return;
  const { data: result } = await proxy.methodCall({
    model: "sale.line",
    method: "set_faster_unit_price",
    args: [{ id: record.id, value: store.unit_price_w_tax, discount: null }],
  });
  if (result.error) return;
  record.unit_price = result.unit_price;
  record.amount_w_tax = result.amount_w_tax;
  record.discount_rate = result.discount_rate;
}

const visibleDiscount = () => {
  const activeRecord = useMainStore.getState().record;
  return activeRecord?.state === "draft";
};

const saleLineView = {
  form_action_add: "modal",
  model: "sale.line",
  table_action: ["add", "edit", "delete"],
  form_action: ["add", "delete", "edit"],
  // access: {
  //   delete: accDelete,
  //   edit: accDelete,
  // },
  otherActions: [],
  selectable: null,
  webfields: {
    product: {
      type: "many2one",
      model: "product.product",
      recSearch: getProduct,
      withChange: onChangeProduct,
      attrs: [
        "id",
        "list_price",
        "name",
        "sale_price_taxed",
        "sale_uom.rec_name",
        "description",
      ],
      required: true,
    },
    "product.code": {
      type: "char",
      readOnly: true,
    },
    unit: {
      type: "many2one",
      model: "product.uom",
      recSearch: searchUnit,
    },
    quantity: {
      type: "integer",
      required: true,
      editable: true,
      default: 1,
      withChange: onChangeQty,
      readOnly: readOnlyQuantity,
      min: 1,
    },
    base_price: { type: "numeric", readOnly: true },
    unit_price: { type: "numeric", decimalPlaces: 2 },
    unit_price_w_tax: {
      type: "numeric",
      withChange: onChangeUnitPriceWtax,
      depends: ["taxes"],
    },
    description: { type: "char" },
    sale_price_taxed: {
      type: "numeric",
    },
    discount_amount: {
      type: "numeric",
      readOnly: true,
      decimalPlaces: 0,
      function: getAmountDiscount,
      search: true,
    },
    discount_rate: {
      type: "char",
      readOnly: true,
      function: getDiscount,
      search: true,
    },

    amount: {
      type: "numeric",
      readOnly: true,
    },
    amount_w_tax: { type: "numeric", function: getAmountWTax, readOnly: true },
    "origin.appointment_date": { type: "char" },
    "origin.time_end": { type: "char" },
    origin: { type: "many2one", readOnly: true },
    add_discount: {
      type: "button_custom_modal",
      readOnly: true,
      color: "sky",
      Component: ProductDiscountItem,
      visible: visibleDiscount,
    },
  },
  webtree: [
    { name: "product", width: "40%" },
    { name: "origin.appointment_date", width: "23%" },
    { name: "quantity", width: "10%" },
    { name: "base_price", width: "23%" },
    { name: "discount_rate", width: "23%" },
    { name: "discount_amount", width: "23%" },
    { name: "unit_price_w_tax", width: "23%" },
    { name: "amount_w_tax", width: "23%" },
    { name: "add_discount", width: "40%" },
  ],
  webform: [
    { name: "product" },
    { name: "unit" },
    { name: "quantity" },
    { name: "unit_price" },
    { name: "unit_price_w_tax" },
    { name: "amount_w_tax" },
    { name: "description" },
  ],
};

export default saleLineView;
